import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'paging-buttons',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './paging-buttons.component.html',
    styleUrl: './paging-buttons.component.css',
})

export class PagingButtonsComponent implements OnInit
{
    public Pages: number[] = [];

    private _page = 0;
    private _pageCount = 0;

    @Input()
    set page(value: number)
    {
        this._page = value;
        this.cd.detectChanges();
    }

    get page(): number
    {
        return this._page;
    }

    @Input()
    set pageCount(value: number)
    {
        this._pageCount = value;
        this.updatePages();
        this.cd.detectChanges();
    }

    @Output() pageSelected = new EventEmitter<number>();

    constructor(private cd: ChangeDetectorRef)
    {
        this.updatePages();
    }

    async ngOnInit()
    {
    }

    public PageSelect(newPage: number)
    {
        this.page = newPage;
        this.pageSelected.emit(newPage);
    }

    private updatePages()
    {
        if (this._pageCount > 1)
        {
            this.Pages = Array.from({ length: this._pageCount }, (_, i) => i);
        }
        else
        {
            this.Pages = [];
        }
    }
}
